var React = require('react');

function NavIconsSearch (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m10.52 17.89a7.41 7.41 0 1 1 7.4-7.41 7.41 7.41 0 0 1 -7.4 7.41zm0-13.78a6.37 6.37 0 1 0 6.37 6.37 6.37 6.37 0 0 0 -6.37-6.37z","key":0}),React.createElement("path",{"d":"m17.35 14.37h1.03v7.32h-1.03z","transform":"matrix(.68721431 -.72645474 .72645474 .68721431 -7.51 18.62)","key":1}),React.createElement("path",{"d":"m10.52 17.89a7.41 7.41 0 1 1 7.4-7.41 7.41 7.41 0 0 1 -7.4 7.41zm0-13.78a6.37 6.37 0 1 0 6.37 6.37 6.37 6.37 0 0 0 -6.37-6.37z","key":2}),React.createElement("path",{"d":"m10.52 17.89a7.41 7.41 0 1 1 7.4-7.41 7.41 7.41 0 0 1 -7.4 7.41zm0-13.78a6.37 6.37 0 1 0 6.37 6.37 6.37 6.37 0 0 0 -6.37-6.37z","key":3})]);
}

NavIconsSearch.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsSearch;

NavIconsSearch.default = NavIconsSearch;
